export default __webpack_public_path__ + "static/media/09.1f1a6445.jpg";